import React, { useState } from "react";
import PropTypes from "prop-types";

import { Control, Column, Label } from "rbx";
import { SystemCodeSelect, BooleanInput } from "../../../components/inputs";
import FilterButtons from "../../../components/FilterButtons";

const INITIAL_FILTER_STATE = { Active: true };
function InspectionMasterFilters({ filters, onFilter, onClose, onReset }) {
  const [inputs, setInputs] = useState({ ...filters });

  const handleChange = e => {
    const { name } = e.target;
    const value =
      e.target.type === "checkbox"
        ? e.target.checked
        : parseInt(e.target.value);
    setInputs({
      ...inputs,
      [name]: value
    });
  };
  const handleClose = () => onClose(onFilter(inputs));
  const handleCancel = () => onClose(onFilter(filters));
  const handleReset = () =>
    onReset ? onReset() : onClose(onFilter({ ...INITIAL_FILTER_STATE }));
  return (
    <div className="inspection-modal-container">
      <Column.Group>
        <Column>
          <Control expanded>
            <SystemCodeSelect
              icon="globe"
              label="Inspection Code"
              lookup={{ Category: "Fleet", Code: "InspectionCd" }}
              name="InspecCdRecIdRef"
              showHelp={false}
              size=""
              value={inputs.InspecCdRecIdRef}
              onChange={handleChange}
            />
          </Control>
        </Column>
        <Column>
          <Control expanded>
            <SystemCodeSelect
              icon="truck"
              label="Vehicle Type"
              lookup={{ Category: "Fleet", Code: "VehicleType" }}
              name="VehicleTypeRecIdRef"
              showHelp={false}
              size=""
              value={inputs.VehicleTypeRecIdRef}
              onChange={handleChange}
            />
          </Control>
        </Column>
        <Column>
          <Control expanded>
            <Label>Active</Label>
            <BooleanInput
              name="Active"
              value={inputs.Active}
              onChange={handleChange}
            />
          </Control>
        </Column>
      </Column.Group>
      <hr />
      <FilterButtons
        handleCancel={handleCancel}
        handleClose={handleClose}
        handleReset={handleReset}
      />
    </div>
  );
}
InspectionMasterFilters.propTypes = {
  filters: PropTypes.object,
  onFilter: PropTypes.func,
  onClose: PropTypes.func,
  onReset: PropTypes.func
};
InspectionMasterFilters.defaultProps = {
  filters: {}
};
export default InspectionMasterFilters;
